import React, { useState, useEffect } from "react";
import { SquareX } from "lucide-react";

const CancelSubscriptionModal = ({
  isOpen,
  onClose,
  onConfirm,
  subscriptionName,
  isSubmitting = false,
}) => {
  const [cancelReason, setCancelReason] = useState("");
  const [error, setError] = useState("");

  // Reset reason and error when modal opens/closes
  useEffect(() => {
    if (!isOpen) {
      setCancelReason("");
      setError("");
    }
  }, [isOpen]);

  const handleConfirm = () => {
    setError("");
    onConfirm(cancelReason.trim());
  };

  const handleClose = () => {
    setCancelReason("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg max-w-md w-full mx-4">
        <div className="bg-hf-gradient rounded-t-lg px-6 py-4 text-center">
          <h3 className="text-xl font-bold text-white">Cancel Subscription</h3>
        </div>
        <div className="p-6">
          <p className="text-gray-600 mb-4">
            {subscriptionName && (
              <span className="font-semibold">{subscriptionName}</span>
            )}
          </p>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Please tell us why you're cancelling (optional):
            </label>
            <textarea
              value={cancelReason}
              onChange={(e) => {
                setCancelReason(e.target.value);
                if (error) setError("");
              }}
              placeholder="Enter your reason here..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-100 resize-none"
              rows={4}
              disabled={isSubmitting}
            />
          </div>

          <div className="flex gap-3">
            <button
              onClick={handleClose}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2.5 bg-primary-100 text-white border-2 rounded-lg font-semibold"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              disabled={isSubmitting}
              className="flex-1 px-4 py-2.5 border-2 hover:bg-gray-300 hover:text-black rounded-lg font-semibold transition-colors disabled:opacity-50"
            >
              {isSubmitting ? "Cancelling..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
